import Image from 'next/image'
import React from 'react'

import CoastLogoCombo from '../images/Coast_Logo_Combo.svg'

export const CoastWordMarkIcon: React.FC<{ height?: number }> = ({ height = 30 }) => {
  return <Image src={CoastLogoCombo} alt="Coast" style={{ height, width: 'auto' }} priority />
}
